module.exports = __webpack_public_path__ + "static/media/secondPlaceMedal.e662fcf3.svg";